import { render, staticRenderFns } from "./Consult_particulars_organization.vue?vue&type=template&id=443f5c5b&scoped=true"
import script from "./Consult_particulars_organization.vue?vue&type=script&lang=js"
export * from "./Consult_particulars_organization.vue?vue&type=script&lang=js"
import style0 from "./Consult_particulars_organization.vue?vue&type=style&index=0&id=443f5c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f5c5b",
  null
  
)

export default component.exports